import { createSelector } from 'reselect';
import _ from 'lodash';

const CustomTextSelector = {
    createGetCustomText: () => createSelector([(state) => state.adminSettingCustom.getCustomText.data], (customText) => {
        if (_.isEmpty(customText)) return {};
        return customText;
    }),

    createGetCustomTextSidebarOrganizer: () => createSelector(
        [(state) => state.registration.registrationViewer.data.settings_texts_sidebar_organizer],
        (sideBarText) => {
            if (_.isEmpty(sideBarText) || _.isUndefined(sideBarText)) return {};
            return sideBarText;
        },
    ),

};

export default CustomTextSelector;
